import React, { useState, useEffect } from 'react'

const Genre = () => {
    const [mymovies, setMymovies] = useState([])
    const [search, setSearch] = useState("")
    console.log(search)
    const base_URL = "https://image.tmdb.org/t/p/original/"
    const moviesAction = async () => {

        const request = await fetch("https://api.themoviedb.org/3/discover/movie?api_key=9a034c1237dc81580749e842bed3fd1c&with_genres=28")
        const response = await request.json()

        const { results } = response
        const data = results
        setMymovies(data)
        console.log(data)
    }
    const moviesComedy = async () => {
        const request = await fetch("https://api.themoviedb.org/3/discover/movie?api_key=9a034c1237dc81580749e842bed3fd1c&with_genres=35")
        const response = await request.json()

        const { results } = response
        const data = results
        setMymovies(data)
        console.log(data)

    }
    const moviesDocumentaries = async () => {
        const request = await fetch("https://api.themoviedb.org/3/discover/movie?api_key=9a034c1237dc81580749e842bed3fd1c&with_genres=99")
        const response = await request.json()

        const { results } = response
        const data = results
        setMymovies(data)

    }
    const moviesHorror = async () => {
        const request = await fetch("https://api.themoviedb.org/3/discover/movie?api_key=9a034c1237dc81580749e842bed3fd1c&with_genres=27")
        const response = await request.json()

        const { results } = response
        const data = results
        setMymovies(data)

    }
    const moviesRomance = async () => {
        const request = await fetch("https://api.themoviedb.org/3/discover/movie?api_key=9a034c1237dc81580749e842bed3fd1c&with_genres=10749")
        const response = await request.json()

        const { results } = response
        const data = results
        setMymovies(data)

    }
    const moviesToprated = async () => {
        const request = await fetch("https://api.themoviedb.org/3/movie/top_rated?api_key=9a034c1237dc81580749e842bed3fd1c&language=en-US")
        const response = await request.json()
        const { results } = response
        const data = results
        setMymovies(data)

    }

    const moviesSearch = async () => {
        const request = await fetch(`https://api.themoviedb.org/3/search/movie?api_key=9a034c1237dc81580749e842bed3fd1c&language=en-US&query=${search}&page=1`)
        const response = await request.json()
        const { results } = response
        const data = results
        setMymovies(data)

    }

    const addTowishlist = (event)   =>{
        event.preventDefault();
        event.stopPropagation();
    }

    useEffect(() => {
        moviesAction()
    }, [])
    return (
        <>
            
                <div className="genre1">
                    <div className="item1" onClick={() => { moviesAction() }}>Action</div>
                    <div className="item1" onClick={() => { moviesComedy() }}>Comedy</div>
                    <div className="item1" onClick={() => { moviesDocumentaries() }}>Documentaries</div>
                    <div className="item1" onClick={() => { moviesHorror() }}>Horror</div>
                    <div className="item1" onClick={() => { moviesRomance() }}>Romance</div>
                    <div className="item1" onClick={() => { moviesToprated() }}>Top</div>
                    <input type="search" value={search} onChange={(event) => { setSearch(event.target.value) }} placeholder="Search for movies.." ></input>
                    <button onClick={() => {
                        moviesSearch()
                    }}>Search</button>
                </div>
            
            <div>
                <div className="container4">
                    {mymovies.map((ele, index) => {
                        return (
                            <div className="container3mono" key={index} >
                                <img className="c3poster1" src={`${base_URL}${ele.poster_path}`} alt="" />
                                <div className="c3poster2">
                                    <h3> {ele.original_title}</h3>
                                    <li>Rating: {ele.vote_average}  </li>
                                    <li>Release: {ele.release_date} </li>
                                    <div className="poster1div1">
                                        <li onClick={(event)=> {addTowishlist(event)}}> WATCHLIST</li>
                                        <li onClick={(event)=> {addTowishlist(event)}}> TRAILER </li>
                                    </div>
                                </div>
                            </div>
                        )
                    })}


                </div>
            </div>
            </>
        
    )
}

export default Genre
